import { Box, Button, Grid, Typography } from "@mui/material";
import React from "react";

const ChannelModal = ({ details, onConfirm, setIsRejectOpen, onCancel }) => {
  const currentData = JSON?.parse(details?.current);
  const proposedData = JSON?.parse(details?.proposed);

  const actorEmail = JSON.parse(sessionStorage.getItem("user")).email;

  return (
    <Grid
      container
      py={6}
      width={"700px"}
      display={"flex"}
      flexDirection={"column"}
      alignItems={"center"}
    >
      <Grid
        item
        width={"80%"}
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
      >
        <Typography
          sx={{
            marginBottom: "12px",
            fontSize: "16px",
            fontWeight: 600,
            lineHeight: "36px",
            color: "#000000",
            fontFamily: "Open-Sans",
          }}
        >
          CHANNEL RULE APPROVAL
        </Typography>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
          }}
        >
          <tbody
            style={{
              margin: "0px auto",
            }}
          >
            <tr className="rule-approval-table-row">
              <td className="rule-approval-table-header-data">
                <p>Current</p>
              </td>
              <td className="rule-approval-table-header-data">
                <p>Proposed</p>
              </td>
            </tr>
            <tr className="rule-approval-table-row">
              <td className="rule-approval-table-data">
                <div className="rule-approval-table-data-cont">
                  <h5>Modifier</h5> <p>{currentData?.Email ?? "-"}</p>
                </div>
              </td>
              <td className="rule-approval-table-data">
                <div className="rule-approval-table-data-cont">
                  <h5>Modifier</h5>
                  <p>{proposedData?.Email ?? "-"}</p>
                </div>
              </td>
            </tr>
            <tr className="rule-approval-table-row">
              <td className="rule-approval-table-data">
                <div className="rule-approval-table-data-cont">
                  <h5>Vendor</h5> <p>{currentData?.Name ?? "-"}</p>
                </div>
              </td>
              <td className="rule-approval-table-data">
                <div className="rule-approval-table-data-cont">
                  <h5>Vendor</h5>
                  <p>{proposedData?.Name ?? "-"}</p>
                </div>
              </td>
            </tr>
            <tr className="rule-approval-table-row">
              <td className="rule-approval-table-data">
                <div className="rule-approval-table-data-cont">
                  <h5>USSD:</h5>
                  <p>{currentData?.Ussd ? "True" : "False"}</p>
                </div>
              </td>
              <td className="rule-approval-table-data">
                <div className="rule-approval-table-data-cont">
                  <h5>USSD:</h5>
                  <p>{proposedData?.Ussd ? "True" : "False"}</p>
                </div>
              </td>
            </tr>

            <tr className="rule-approval-table-row">
              <td className="rule-approval-table-data">
                <div className="rule-approval-table-data-cont">
                  <h5>MOBILE:</h5>
                  <p>{currentData?.Mobile ? "True" : "False"}</p>
                </div>
              </td>
              <td className="rule-approval-table-data">
                <div className="rule-approval-table-data-cont">
                  <h5>MOBILE:</h5>
                  <p>{proposedData?.Mobile ? "True" : "False"}</p>
                </div>
              </td>
            </tr>

            <tr className="rule-approval-table-row">
              <td className="rule-approval-table-data">
                <div className="rule-approval-table-data-cont">
                  <h5>INTERNET:</h5>
                  <p>{currentData?.Internet ? "True" : "False"}</p>
                </div>
              </td>
              <td className="rule-approval-table-data">
                <div className="rule-approval-table-data-cont">
                  <h5>INTERNET:</h5>
                  <p>{proposedData?.Internet ? "True" : "False"}</p>
                </div>
              </td>
            </tr>

            <tr className="rule-approval-table-row">
              <td className="rule-approval-table-data">
                <div className="rule-approval-table-data-cont">
                  <h5>ATM:</h5> <p>{currentData?.Atm ? "True" : "False"}</p>
                </div>
              </td>
              <td className="rule-approval-table-data">
                <div className="rule-approval-table-data-cont">
                  <h5>ATM:</h5>
                  <p>{proposedData?.Atm ? "True" : "False"}</p>
                </div>
              </td>
            </tr>

            <tr className="rule-approval-table-row">
              <td className="rule-approval-table-data">
                <div className="rule-approval-table-data-cont"></div>
              </td>
              <td className="rule-approval-table-data">
                <div className="rule-approval-table-data-cont">
                  <h5>Date Created</h5>
                  <p className="rule-approval-date">
                    {details?.createdAt
                      ? `${details?.createdAt?.substring(0, 10)} - 
                    ${details?.createdAt?.substring(11, 16)}`
                      : "-"}
                  </p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <Box
          py={2}
          display={details?.approvalStatus === "PENDING" ? "flex" : "none"}
          justifyContent={"space-around"}
          columnGap={"20px"}
        >
          <Button
            variant="contained"
            sx={{
              background: "#fff",
              textTransform: "capitalize",
              color: "#255cff",
              fontFamily: "Open-Sans",
              border: "2px solid #255cff",
              boxShadow: "none",
              "&:hover": {
                backgroundColor: "#B3B3B3",
              },
            }}
            onClick={() => {
              setIsRejectOpen(true);
              onCancel();
            }}
          >
            Reject
          </Button>
          <Button
            variant="contained"
            sx={{
              background: "#255cff",
              textTransform: "capitalize",
              fontFamily: "Open-Sans",
              "&:hover": {
                backgroundColor: "#255cff",
              },
            }}
            onClick={() => {
              onConfirm(actorEmail, details?.id);
            }}
          >
            Approve
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ChannelModal;
